module.exports = __webpack_public_path__ + "static/media/27OCHA13.f910dc34.jpg";